import ActiveCompaniesList from "@components/ActiveCompaniesList/ActiveCompaniesList";
import React from "react";
import styles from "./CompaniesSection.module.scss";
import classNames from "classnames";
import SearchIcon from "@components/Icons/SearchIcon";
import { useTranslations } from "next-intl";

export default function CompaniesSection({ onTotalCountChange }) {
    const t = useTranslations("CustomersPage");
    const [sortBy, setSortBy] = React.useState("top");
    const [filterBy, setFilterBy] = React.useState(null);
    const [searchQuery, setSearchQuery] = React.useState(null);
    const [debouncedSearchQuery, setDebouncedSearchQuery] =
        React.useState(null);

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchQuery(searchQuery);
        }, 500);
        return () => clearTimeout(handler);
    });

    const handleFilterBy = (e) => {
        const name = e.currentTarget.getAttribute("data-name");
        setFilterBy(filterBy === name ? null : name);
    };

    const handleSortBy = (e) => {
        setSortBy(e.currentTarget.getAttribute("data-name"));
    };

    const handleSearchQueryChanged = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.toolbar}>
                <div className={styles.toolbarRow}>
                    <div className={styles.controlGroup}>
                        <div className={styles.segmented}>
                            <button
                                data-name="top"
                                onClick={handleSortBy}
                                className={classNames(
                                    styles.segBtn,
                                    sortBy === "top" && styles.segBtnActive,
                                )}
                            >
                                {t("after_success")}
                            </button>
                            <button
                                data-name="asc"
                                onClick={handleSortBy}
                                className={classNames(
                                    styles.segBtn,
                                    sortBy === "asc" && styles.segBtnActive,
                                )}
                            >
                                {t("alphabetical_order")}
                            </button>
                        </div>

                        <div className={styles.divider} />

                        <div className={styles.filterChips}>
                            <button
                                data-name="company"
                                onClick={handleFilterBy}
                                className={classNames(
                                    styles.chip,
                                    filterBy === "company" && styles.chipActive,
                                )}
                            >
                                {t("companies")}
                            </button>
                            <button
                                data-name="institution"
                                onClick={handleFilterBy}
                                className={classNames(
                                    styles.chip,
                                    filterBy === "institution" &&
                                        styles.chipActive,
                                )}
                            >
                                {t("institutions")}
                            </button>
                        </div>
                    </div>

                    <div className={styles.searchWrapper}>
                        <SearchIcon className={styles.searchIcon} />
                        <input
                            type="text"
                            onChange={handleSearchQueryChanged}
                            value={searchQuery || ""}
                            placeholder={t("search_placeholder")}
                            className={styles.searchInput}
                        />
                    </div>
                </div>
            </div>

            <div className={styles.listContainer}>
                <ActiveCompaniesList
                    sort={sortBy}
                    filter={filterBy}
                    search={debouncedSearchQuery}
                    onTotalCountChange={onTotalCountChange}
                    onClearSearch={() => {
                        setDebouncedSearchQuery(null);
                        setSearchQuery(null);
                        setFilterBy(null);
                    }}
                />
            </div>
        </div>
    );
}
